import { IconChevron, Text, Columns, Column } from 'braid-design-system';
import type * as React from 'react';

interface Props {
  isMobile?: boolean;
  label: React.ReactNode;
  direction?: React.ComponentProps<typeof IconChevron>['direction'];
  weight?: React.ComponentProps<typeof Text>['weight'];
  size?: React.ComponentProps<typeof Text>['size'];
}

export const SortOrderDropdownTrigger: React.FC<Props> = ({
  label,
  direction = 'down',
  weight = 'regular',
  size = 'standard',
}) => (
  <Columns space="xxsmall" alignY="bottom">
    <Column>
      <Text weight={weight} size={size} baseline={false} align="right">
        {label}{' '}
      </Text>
    </Column>
    <Column width="content">
      <Text weight={weight} size={size} baseline={false}>
        <IconChevron direction={direction} alignY="lowercase" />
      </Text>
    </Column>
  </Columns>
);
